<template>
    <div id="chargePanel">
        <popup ref="popup" type="center" @close="popClose">
            <div class="charge_panel">
                <div class="panel_header">
                    <div class="panel_title">字数充值包</div>
                    <router-link class="update_btn" to="/membership">常言道：听人劝，吃饱饭！请点此升级会员</router-link>
                </div>
                <div class="panel_content">
                    <div class="content_main">
                        <div class="setmeal">
                            <div @click="chooseSetMeal(meal)" :class="['meal_item',{'active':selectMeal.vip_type==meal.vip_type}]" v-for="meal in vipData.goods" :key="meal.id">
                                <div v-if="meal.tip" class="meal_tag">{{meal.tip}}</div>
                                <div class="word_count">{{ meal.gift_days }}字</div>
                                <div class="meal_price">￥<span class="price_num">{{ meal.pay_money }}</span></div>
                                <div class="item_bottom">{{ meal.tip2 }}</div>
                            </div>
                        </div>
                        <div class="pay_wrap">
                            <div class="pay_code">
                                <canvas class="timeout" id="chargeCanvas"></canvas>
                                <div class="jiao"></div>
                            </div>
                            <div class="pay_info">
                                <div class="line_one">应付金额：<span class="pay_money">￥<span class="money_count">{{ selectMeal.pay_money }}</span></span><span class="pay_desc">≈ {{selectMeal.xh_times}}本新华字典</span><span class="pay_desc" v-if="coupon_id">会员专享券：{{coupon_money}}元</span></div>
                                <div class="line_two">请使用
                                    <!-- <span class="pay_type wx_pay"><img class="pay_icon" src="../views/img/img_icon_91.png" alt="">微信支付</span>或 -->
                                    <span class="pay_type ali_pay"><img class="pay_icon" src="../views/img/img_icon_92.png" alt="">支付宝</span>扫一扫二维码进行支付</div>
                                <div class="agreement"><el-checkbox v-model="agreement"></el-checkbox> 开通会员代表您接受 <a target="_blank" href="http://help.xiutanshu.com/help/agree.html">《订阅会员协议》</a>，开发票请联系在线客服</div>
                            </div>
                        </div>
                    </div>
                    <div class="content_aside">
                        <img class="logo" src="./img/logo_black.png" alt="">
                        <div class="slogin">专业AI写作·放空您的大脑和双手</div>
                        <div class="aside_list">
                            <div class="list_item">
                                <div class="item_no">01、</div>
                                <div class="item_content">所有字数包统一按照钻石会员权益发放，并永久有效。</div>
                            </div>
                            <div class="list_item">
                                <div class="item_no">02、</div>
                                <div class="item_content">只有老会员才享有字数包专享优惠券，新用户不可用。</div>
                            </div>
                            <div class="list_item">
                                <div class="item_no">03、</div>
                                <div class="item_content">虚拟产品，支付成功之后，非软件故障等原因，暂不支持退款，敬请谅解。</div>
                            </div>
                            <div class="list_item">
                                <div class="item_no">04、</div>
                                <div class="item_content">一端付款，支持多端使用，无需另外付费。</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="close_btn" @click="popClose"></div>
            </div>
        </popup>
    </div>
</template>
<script type="text/ecmascript-6">
    import popup from "COMPONENTS/Popup.vue"
    import QRCode from 'qrcode'
    export default {
        components:{popup},
        data() {
            return {
                selectMeal:{},
                vipData:[
                    {
                        id:1,
                        word_count:320000,
                        price:39.9,
                        percent:58,
                        is_recommend:1,
                        xh_times:58
                    },
                    {
                        id:2,
                        word_count:160000,
                        price:29.9,
                        percent:29,
                        is_recommend:0,
                        xh_times:29
                    },
                    {
                        id:3,
                        word_count:80000,
                        price:19.9,
                        percent:11,
                        is_recommend:0,
                        xh_times:14.6
                    },
                    {
                        id:4,
                        word_count:20000,
                        price:9.9,
                        percent:17,
                        is_recommend:0,
                        xh_times:3.7
                    },
                ],
                coupon_money:0,
                coupon_id:0,
                agreement:true,
            }
        },
        created() {
            // this.fetchGoodsList();
            
        },
        methods: {
            show(){
                this.fetchGoodsList()
                this.$refs.popup.show();
            },
            popClose(){
                this.$refs.popup.close();
            },
            fetchGoodsList(){
                this.$http.get('/front/aixz/membership/words/').then((res) => {
                    if(res.status == 200){
                        this.vipData = res.data.vip_info;
                        this.selectMeal = this.vipData.goods[0];
                        this.chooseSetMeal(this.selectMeal)
                    }
                })
            },
            chooseSetMeal(vip){
                this.selectMeal = vip;
                //如果支付二维码可以放在payTypes列表中，就不需要请求接口了
                let data = { "appid":APP_ID,"pay_type":this.vipData.pay_type, "vip_type":vip.vip_type, "pay_from": "h5pay", "pay_flat": 1}

                this.$http.post('/front/aixz/chongzhi/?scanpay=1', data).then((res) => {
                    if(res.status == 200){
                        this.code_url = res.data.pay_url;
                        this.uniq_key = res.data.uniq_key;
                        var canvas = document.getElementById('chargeCanvas')
                        QRCode.toCanvas(canvas, this.code_url, function (error) {
                            if (error) console.error(error)
                        })
                    }
                })
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .charge_panel{
        width: 1000px;
        position: relative;
        padding: 20px 20px 30px;
        background-color: #fff;
        border-radius: 5px;
        .panel_header{
            display: flex;
            background-color: #424242;
            align-items: center;
            border-radius: 4px;
            padding-right: 14px;
            height: 60px;
            margin-bottom: 20px;
            .panel_title{
                flex-grow: 1;
                text-align: center;
                padding-right: 20px;
                color: #fff;
            }
            .update_btn{
                white-space: nowrap;
                background-color: #fff;
                color: #999;
                padding: 0 10px;
                font-size: 12px;
                line-height: 30px;
                border-radius: 2px;
            }
        }
        .panel_content{
            display: flex;
            .content_main{
                flex-grow: 1;
                margin-right: 20px;
                .setmeal{
                    display: flex;
                    justify-content: space-between;
                    padding-bottom: 39px;
                    border-bottom: 1px dashed #ddd;
                    .meal_item{
                        width: 151px;
                        height: 207px;
                        border-radius: 4px;
                        border: 1px solid #ddd;
                        padding: 31px 12px 0;
                        position: relative;
                        text-align: center;
                        cursor: pointer;
                        &.active{
                            border: 2px solid #424242;
                            padding-top: 30px;
                            &::after{
                                content: "";
                                display: block;
                                width: 32px;
                                height: 32px;
                                background-image: url("./img/img_icon_04.png");
                                background-size: 100% 100%;
                                position: absolute;
                                right: -2px;
                                bottom: -2px;
                            }
                            .meal_price{
                                border-color: #424242;
                            }
                        }
                        .meal_tag{
                            position: absolute;
                            top: -11px;
                            left: -1px;
                            background-color: #424242;
                            color: #fff;
                            font-size: 12px;
                            text-align: center;
                            line-height: 22px;
                            width: 68px;
                            border-radius: 11px 0 11px 0;
                        }
                        .word_count{
                            line-height: 32px;
                            font-size: 12px;
                            margin-bottom: 20px;
                        }
                        .meal_price{
                            font-size: 15px;
                            line-height: 39px;
                            padding-bottom: 24px;
                            border-bottom: 1px dashed #ccc;
                            .price_num{
                                font-size: 28px;
                                padding-left: 8px;
                            }
                        }
                        .item_bottom{
                            color: #999;
                            font-size: 12px;
                            margin-top: 13px;
                            line-height: 32px;
                        }
                    }
                }
                .pay_wrap{
                    display: flex;
                    padding-top: 30px;
                    .pay_code{
                        width: 150px;
                        height: 150px;
                        border: 1px solid #e1e1e1;
                        padding: 8px;
                        margin-right: 30px;
                        position: relative;
                        .timeout{
                            display: block;
                            width: 100%!important;
                            height: 100%!important;
                        }
                        &:before,&:after,.jiao:before,.jiao:after{
                            content: "";
                            display: block;
                            position: absolute;
                            width: 20px;
                            height: 20px;
                            border: 1px solid #07c160;
                        }
                        &:before{
                            top: -1px;
                            left: -1px;
                            border-right: none;
                            border-bottom: none;
                        }
                        &:after{
                            top: -1px;
                            right: -1px;
                            border-left: none;
                            border-bottom: none;
                        }
                        .jiao:before{
                            bottom: -1px;
                            left: -1px;
                            border-right: none;
                            border-top: none;
                        }
                        .jiao:after{
                            bottom: -1px;
                            right: -1px;
                            border-left: none;
                            border-top: none;
                        }
                    }
                    .pay_info{
                        flex-grow: 1;
                        .line_one{
                            font-size: 12px;
                            margin-bottom: 14px;
                            line-height: 34px;
                            .pay_money{
                                color: #07c160;
                                .money_count{
                                    font-size: 28px;
                                    font-weight: bold;
                                    padding-left: 8px;
                                }
                            }
                            .pay_desc{
                                padding-left: 40px;
                                color: #999;
                            }
                        }
                        .line_two{
                            line-height: 34px;
                            font-weight: bold;
                            margin-bottom: 52px;
                            .pay_type{
                                padding: 0 14px;
                                &.wx_pay{
                                    color: #09bb07;
                                }
                                &.ali_pay{
                                    color: #009fe8;
                                }
                                .pay_icon{
                                    vertical-align: middle;
                                    margin: -2px 8px 0 0;
                                    width: 16px;
                                }
                            }
                        }
                        .agreement{
                            font-size: 12px;
                            color: #ccc;
                            line-height: 16px;
                            a{
                                color: #07c160;
                            }
                        }
                    }
                }
            }
            .content_aside{
                width: 260px;
                background-color: #f5f5f5;
                border-radius: 4px;
                padding: 28px 20px 0;
                flex-shrink: 0;
                font-size: 12px;
                line-height: 22px;
                .logo{
                    margin: 0 auto;
                    display: block;
                }
                .slogin{
                    padding: 30px 0;
                    text-align: center;
                }
                .aside_list{
                    .list_item{
                        padding-left: 36px;
                        position: relative;
                        margin-bottom: 20px;
                        color: #999;
                        .item_no{
                            position: absolute;
                            left: 0;
                            top: 0;
                        }
                    }
                }
            }
        }
        .close_btn{
            position: absolute;
            bottom: -61px;
            left: 50%;
            transform: translateX(-50%);
            width: 25px;
            height: 25px;
            background-image: url("./img/update_close.png");
            cursor: pointer;
            background-size: 100% 100%;
        }
    }
</style>